import { render, staticRenderFns } from "./AiChatButton.vue?vue&type=template&id=17945526&scoped=true&"
import script from "./AiChatButton.vue?vue&type=script&lang=ts&"
export * from "./AiChatButton.vue?vue&type=script&lang=ts&"
import style0 from "./AiChatButton.vue?vue&type=style&index=0&id=17945526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17945526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
